import type { FC, ReactElement, ReactNode } from 'react'

import './data-point.scss'

export const DataPoints: FC<{ children: ReactNode; isCard?: boolean }> = ({
  isCard = false,
  children,
}) => <div className={`data-points ${isCard ? 'is-card' : ''}`}>{children}</div>

const DataPoint: FC<{
  header?: ReactElement | string
  value?: string | ReactElement
  className?: string
}> = ({ header = '', value = '', className = '' }) => (
  <div className={`data-point ${className}`}>
    {header && <h4>{header}</h4>}

    <div className="data-point__value">{value}</div>
  </div>
)

export default DataPoint
